// Landing page — xizmat sahifasi kontenti (uz / ru)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "Landing page yaratish — narxi 4 mln so'mdan | Innobek",
        description:
            "Landing page yaratish 4 000 000 so'mdan. Bir sahifali sotuvchi sayt 5–10 kunda tayyor: mobil moslashuv, Telegram'ga ariza, analitika va 6 oy qo'llab-quvvatlash.",
        keywords: [
            "landing page yaratish",
            "landing page narxi",
            "bir sahifali sayt",
            "lending sayt buyurtma",
            "Toshkentda landing page",
            "sotuvchi sayt yasash",
        ],
    },
    hero: {
        eyebrow: "Landing page",
        h1: "Landing page yaratish — reklamadan ariza keltiradigan bitta sahifa",
        lead:
            "Bir sahifali sayt eng tez ishga tushadigan sotuv vositasi. Biz uni reklama trafigi ostiga quramiz: mobil ekran uchun chizamiz, ariza Telegram'ga tushadi, tezlik va analitika sozlangan holda topshiriladi. Odatiy muddat — 5–10 ish kuni.",
        ctaPrimary: "Bepul konsultatsiya",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "5–10 kunda ishga tushirish",
            "PageSpeed mobilda 85+",
            "Ariza to'g'ridan-to'g'ri Telegram'ga",
            "6 oy texnik qo'llab-quvvatlash",
        ],
    },
    intro: {
        h: "Landing page nima va u qachon kerak bo'ladi?",
        p: [
            "Landing page — foydalanuvchini bitta harakatga olib boradigan bir sahifali sayt. Menyu bo'ylab kezish shart emas: sahifani yuqoridan pastga aylantirasiz va kim taklif qilayotganini, nima taklif qilinayotganini, narxi qancha ekanini hamda keyin nima qilish kerakligini bilib olasiz. Aynan shu soddalik tufayli bir sahifali sayt reklama trafigini arizaga aylantirishda ko'p sahifali saytdan samaraliroq ishlaydi.",
            "Innobek landing page'ni dizayn mashqi sifatida emas, sotuv vositasi sifatida quradi. Avval kimga sotayotganingizni va mijoz qanday e'tiroz bilan keladigan ini aniqlaymiz. Keyin bloklar ketma-ketligini shunga qarab tuzamiz: sarlavha, foyda, isbot, narx, savol-javob va ariza shakli. Har bir blok bitta vazifani bajaradi — chalg'ituvchi bezak qo'shmaymiz.",
            "Bu xizmat hammaga ham kerak emas. Agar sizda o'nlab xizmat yo'nalishi, muntazam yangilanadigan katalog yoki yangiliklar bo'limi bo'lsa, bitta sahifa tor keladi — bunday holda korporativ sayt yoki internet-do'kon to'g'riroq tanlov bo'ladi. Konsultatsiyada buni ochiq aytamiz va kerak bo'lmagan tarifni sotmaymiz.",
            "Amaliyotda landing page ikki xil vazifani bajaradi. Birinchisi — Google Ads, Instagram yoki Telegram reklamasi ostidagi qo'nish sahifasi. Ikkinchisi — kichik biznesning asosiy sayti, ya'ni internetdagi rasmiy yuzi. Ikkala holatda ham texnik asos bir xil: tez yuklanish, mobil moslashuv, to'g'ri meta teglar va ishlaydigan ariza shakli.",
            "Muhim bir narsani oldindan aytamiz: sahifaning o'zi mijoz olib kelmaydi. U trafikni arizaga aylantiradigan vosita, xolos. Odam kelishi uchun reklama, SEO yoki ijtimoiy tarmoq kerak. Shuning uchun biz sahifani topshirishdan oldin Google Analytics va konversiya maqsadlarini sozlaymiz — birinchi kundanoq qaysi kanal ishlayotgani ko'rinib tursin.",
        ],
    },
    definition: {
        term: "Landing page nima?",
        text:
            "Landing page — bitta taklifni sotishga mo'ljallangan bir sahifali veb-sayt. Unda barcha ma'lumot ketma-ket joylashtiriladi va foydalanuvchi bitta maqsadga — ariza qoldirish yoki qo'ng'iroq qilishga yo'naltiriladi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifda standart tarzda bor",
        sub: "Bular alohida to'lanadigan qo'shimcha emas — hatto eng arzon tarifda ham kiradi.",
        items: [
            "Bepul konsultatsiya va texnik topshiriq tuzish",
            "Domen ro'yxatdan o'tkazishda yordam va DNS sozlash",
            "Bepul SSL sertifikati va HTTPS ulanish",
            "Mobil, planshet va kompyuterda tekshirilgan moslashuv",
            "Ariza shakli hamda Telegram'ga xabar yuborish",
            "Rasm siqish, kesh va tezlik optimizatsiyasi",
            "Meta teglar, sitemap.xml, robots.txt va Open Graph",
            "Google Analytics va Search Console'ga ulash",
            "Saytni boshqarish bo'yicha qisqa video-qo'llanma",
            "Topshirgandan keyin 6 oy texnik qo'llab-quvvatlash",
        ],
    },
    benefits: {
        eyebrow: "Afzalliklari",
        h: "Nega bitta sahifa ko'pincha katta saytdan yaxshi ishlaydi",
        sub: "Landing page kuchini hajmdan emas, fokusdan oladi. Quyida buning amaliy natijalari.",
        items: [
            {
                t: "Byudjet oldindan aniq",
                d: "Sahifa bitta bo'lgani uchun dizayn va dasturlash hajmi kichik. Narx korporativ saytnikidan ikki-uch barobar past, smeta esa boshida to'liq kelishiladi — yo'l-yo'lakay qo'shimcha to'lov chiqmaydi.",
            },
            {
                t: "Tez ishga tushadi",
                d: "Oddiy variant 5–7 ish kunida, individual dizayn va animatsiya bilan 10–15 kunda topshiriladi. Reklama kampaniyasini bir-ikki oy kutib o'tirmaysiz.",
            },
            {
                t: "Konversiya yuqoriroq",
                d: "Foydalanuvchi oldida bitta yo'l bor: ariza qoldirish yoki qo'ng'iroq qilish. Diqqatni bo'ladigan menyu va ichki havolalar yo'q, shuning uchun bir xil trafikdan ko'proq murojaat olinadi.",
            },
            {
                t: "Mobil birinchi o'rinda",
                d: "O'zbekistonda tashriflarning katta qismi telefondan keladi. Maket avval telefon ekrani uchun chiziladi, keyin kompyuterga kengaytiriladi — teskarisiga emas. Shakl va tugmalar barmoq uchun qulay o'lchamda bo'ladi.",
            },
            {
                t: "Reklama uchun tayyor",
                d: "Google Analytics, Meta Pixel va konversiya maqsadlari o'rnatiladi. Tezlik optimizatsiyasi bosish narxini tushiradi, UTM belgilash esa qaysi kanal ariza berayotganini ko'rsatadi.",
            },
            {
                t: "Keyin kengaytirsa bo'ladi",
                d: "Biznes o'sganda landing page'ni korporativ saytga yoki internet-do'konga aylantiramiz. Dizayn tizimi va kod qayta ishlatiladi, shuning uchun kengaytirish noldan qurishdan arzonroq tushadi.",
            },
            {
                t: "Natija o'lchanadi",
                d: "Sahifa tayyor bo'lgach, nechta tashrif nechta arizaga aylanayotganini ko'rasiz. Konversiya past bo'lsa, sabab aniq bo'ladi: sarlavha, narx yoki shakl. Taxmin qilib emas, raqamga qarab tuzatish kiritamiz.",
            },
            {
                t: "Kod va materiallar sizniki",
                d: "Topshirishda domen, hosting kirish ma'lumotlari, Figma maketi va kod arxivi sizga beriladi. Bizga bog'lanib qolmaysiz — xohlasangiz saytni boshqa jamoa ham davom ettira oladi.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimga mos",
        h: "Landing page qaysi holatlarda eng foydali",
        sub: "Quyidagi vaziyatlarda bir sahifali sayt eng tejamkor va tez natija beradigan yechim.",
        items: [
            {
                t: "Bitta xizmat yoki mahsulot sotuvchilar",
                d: "Stomatologiya, klinika, ta'mirlash, yuridik xizmat, jihoz sotuvi. Taklif aniq bo'lsa, bitta sahifa hammasini aytishga yetadi.",
            },
            {
                t: "Reklamaga byudjet ajratganlar",
                d: "Google Ads yoki Instagram'ga pul sarflayotgan bo'lsangiz, trafikni Instagram profiliga emas, sotuvchi sahifaga yo'naltirish arzonga tushadi.",
            },
            {
                t: "Kurs va tadbir tashkilotchilari",
                d: "Dastur, spikerlar, narx va ro'yxatdan o'tish shakli bitta sahifada. Arizalar Telegram guruhiga tushadi, jadval qo'lda yuritilmaydi.",
            },
            {
                t: "Yangi boshlangan biznes",
                d: "Byudjet cheklangan bo'lsa, avval landing page bilan chiqing va talabni sinang. Natija ko'ringach, kengroq saytga o'tasiz.",
            },
            {
                t: "Aksiya va yangi mahsulot chiqishi",
                d: "Har bir kampaniya uchun alohida sahifa ochiladi va natijasi alohida o'lchanadi. Asosiy saytga tegilmaydi.",
            },
            {
                t: "Tender va hamkorlik uchun",
                d: "Rasmiy saytning yo'qligi jiddiy shartnomalarda to'siq bo'ladi. Bir sahifali sayt bu masalani bir hafta ichida yopadi.",
            },
            {
                t: "Qurilish va ko'chmas mulk obyektlari",
                d: "Har bir turar-joy majmuasi yoki obyekt uchun alohida sahifa ochiladi: joylashuv, planirovka, narx va bron shakli bitta joyda turadi.",
            },
            {
                t: "Xorijiy mijozga chiqayotganlar",
                d: "Ingliz yoki rus tilidagi alohida versiya eksport va autsorsing xizmatlari uchun ishlaydi. Matn tarjima emas, o'sha bozor uchun qaytadan yoziladi.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Landing page narxi — uch tarif",
        sub: "Narxlar oshkora. Har bir tarifga domen sozlash, joylashtirish va qo'llab-quvvatlash kiradi.",
        note:
            "Yakuniy hisob-kitob bepul konsultatsiyadan keyin, bloklar soni va funksionalga qarab tasdiqlanadi. To'lov ikki bosqichda: 50% boshida, 50% topshirishda. Domen va hosting to'lovi provayderga alohida to'lanadi — yiliga taxminan 400 000 – 1 200 000 so'm.",
        tiers: [
            {
                name: "Start",
                tagline: "Byudjetli bir sahifali sayt",
                price: "4 000 000",
                priceNote: "so'mdan",
                term: "5–7 ish kuni",
                best: "Yangi biznes va bitta xizmatni sotish uchun",
                features: [
                    "Tayyor asosda moslashtirilgan dizayn",
                    "6–8 ta kontent bloki",
                    "Barcha qurilmalarga moslashuv",
                    "Ariza shakli va Telegram'ga xabar",
                    "Bazaviy texnik SEO",
                    "Google Analytics ulash",
                    "Domen va hosting sozlash",
                    "6 oy qo'llab-quvvatlash",
                ],
            },
            {
                name: "Business",
                tagline: "Individual dizayn va adminka",
                price: "9 000 000",
                priceNote: "so'mdan",
                term: "10–15 ish kuni",
                best: "Faol reklama qilayotgan va kontentni o'zi boshqaradigan biznes",
                featured: true,
                features: [
                    "Figma'da noldan chizilgan dizayn",
                    "Scroll animatsiyalari va mikro-interaksiya",
                    "Admin panel: matn, rasm va narxni o'zingiz tahrirlaysiz",
                    "Ikki yoki uch tilli versiya",
                    "Sotuvga yo'naltirilgan matn yozish",
                    "Kengaytirilgan SEO va Schema.org belgilash",
                    "Meta Pixel va konversiya maqsadlari",
                    "CRM yoki Google Sheets bilan integratsiya",
                    "6 oy qo'llab-quvvatlash",
                ],
            },
            {
                name: "Premium",
                tagline: "Nostandart yechim",
                price: "18 000 000",
                priceNote: "so'mdan",
                term: "3–6 hafta",
                best: "Kalkulyator, bron qilish yoki murakkab integratsiya kerak bo'lganda",
                features: [
                    "Interaktiv sahnalar, video-fon va 3D elementlar",
                    "Kalkulyator, konfigurator yoki bron moduli",
                    "Onlayn to'lov: Payme, Click, Uzum",
                    "amoCRM, Bitrix24 yoki 1C bilan integratsiya",
                    "A/B testlash va konversiya optimizatsiyasi",
                    "Yuklama uchun infratuzilma va monitoring",
                    "Shaxsiy loyiha menejeri",
                    "12 oy qo'llab-quvvatlash",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Landing page qanday yaratiladi",
        sub: "Olti bosqich. Har bosqich oxirida natijani ko'rasiz va tasdiqlaysiz — keyingi bosqich shundan keyin boshlanadi.",
        steps: [
            {
                t: "Konsultatsiya va brif",
                time: "1 kun",
                d: "Biznesingiz, mijoz portreti va raqobatchilarni muhokama qilamiz. Qaysi tarif yetarli ekanini aytamiz. Shu bosqichda aniq narx va muddat belgilanadi.",
            },
            {
                t: "Tuzilma va matn",
                time: "1–2 kun",
                d: "Bloklar ketma-ketligini tuzamiz va har bir blok uchun matn yozamiz. Sarlavhalar mijozning e'tirozini yopadigan qilib tanlanadi. Siz tasdiqlaysiz.",
            },
            {
                t: "Dizayn",
                time: "2–5 kun",
                d: "Figma'da mobil va desktop maketi chiziladi. Rang, shrift va uslub brendingizga moslashtiriladi. Kelishilgan doirada tuzatishlar bepul kiritiladi.",
            },
            {
                t: "Dasturlash va sinov",
                time: "3–7 kun",
                d: "Sayt React asosida quriladi, tezlik va SEO optimallashtiriladi. Shakllar, brauzerlar va turli ekran o'lchamlari qo'lda sinovdan o'tkaziladi.",
            },
            {
                t: "Ishga tushirish",
                time: "1 kun",
                d: "Domen ulanadi, analitika va konversiyalar sozlanadi, sayt Google'ga yuboriladi. Sizga qo'llanma topshiriladi va qo'llab-quvvatlash muddati boshlanadi.",
            },
            {
                t: "Kuzatuv va tuzatish",
                time: "6 oy",
                d: "Birinchi haftalarda arizalar statistikasiga qaraymiz. Kerak bo'lsa sarlavha, tugma joylashuvi yoki shakl maydonlarini o'zgartiramiz — bu qo'llab-quvvatlash doirasiga kiradi.",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "So'nggi ishlarimizdan",
        sub: "Har bir loyiha noldan chizilgan: tuzilma, dizayn, matn va texnik qismi bizniki.",
        cta: "Barcha loyihalar",
        slugs: ["mountain-and-sea", "avantika-medex", "global-building-group", "atlet"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Landing page yaratish bo'yicha eng ko'p so'raladigan savollarga aniq javoblar.",
        items: [
            {
                q: "Landing page yaratish qancha turadi?",
                a: "Narx 4 000 000 so'mdan boshlanadi. Bu tayyor asosda moslashtirilgan, mobilga to'liq mos va indekslanishga tayyor sahifa. Individual dizayn, animatsiya va admin panel bilan to'liq variant 9 000 000 so'mdan. Kalkulyator, to'lov tizimi yoki CRM integratsiyasi kerak bo'lsa, narx 18 000 000 so'mdan boshlanadi va loyiha hajmiga qarab aniqlanadi.",
            },
            {
                q: "Bir sahifali sayt necha kunda tayyor bo'ladi?",
                a: "Start tarifi odatda 5–7 ish kunida topshiriladi, Business tarifi 10–15 ish kunini oladi. Premium yechimlar uchun 3–6 hafta kerak. Muddat sizdan matn, logotip va rasm qanchalik tez kelishiga bog'liq. Kontent tayyor bo'lsa, jarayon bir-ikki kunga qisqaradi. Muddat shartnomada qayd etiladi va kechikish ehtimoli bo'lsa, oldindan xabar beramiz.",
            },
            {
                q: "Landing page bilan bir sahifali sayt bir xilmi?",
                a: "Amalda ha. Landing page atamasi ko'proq reklama trafigi tushadigan qo'nish sahifasiga nisbatan ishlatiladi, bir sahifali sayt esa kompaniyaning asosiy sayti vazifasini bajaradigan formatga nisbatan. Tuzilishi bir xil — farq maqsadda. Biz ikkala vazifani ham bajaradigan qilib quramiz. Ya'ni sahifa reklamada ham, qidiruvda ham ishlaydi.",
            },
            {
                q: "Saytni o'zim tahrirlay olamanmi?",
                a: "Business va Premium tariflarda admin panel beriladi: matn, rasm, narx va bloklarni dasturchisiz o'zgartirasiz. Start tarifida adminka yo'q, lekin olti oylik qo'llab-quvvatlash davomida kichik o'zgartirishlarni biz bepul kiritamiz. Adminkani keyinroq ham qo'shish mumkin. Uning narxi sahifa tuzilmasiga bog'liq va odatda 3 000 000 so'mdan boshlanadi.",
            },
            {
                q: "Landing page Google'da chiqadimi?",
                a: "Sayt indekslanishga tayyor holda topshiriladi: to'g'ri meta teglar, semantik sarlavhalar, sitemap.xml, robots.txt va Schema.org belgilash o'rnatiladi. Ammo bitta sahifa cheklangan miqdordagi so'rov bo'yicha chiqadi. Raqobatli so'rovlar uchun doimiy SEO ishi va kontent kerak — buni alohida xizmat sifatida qilamiz. Odatda birinchi sezilarli natijalar uch-olti oydan keyin ko'rinadi.",
            },
            {
                q: "Domen va hosting narxga kiradimi?",
                a: "Sozlash ishlari narxga kiradi: domenni ro'yxatdan o'tkazishda yordam beramiz, DNS'ni ulaymiz, SSL o'rnatamiz. Domen va hosting to'lovi esa provayderga to'g'ridan-to'g'ri to'lanadi — yiliga taxminan 400 000 – 1 200 000 so'm. Qaysi variant sizga tejamkor ekanini aytamiz. Domen sizning nomingizga rasmiylashtiriladi, biz uni o'zimizda saqlamaymiz.",
            },
            {
                q: "Arzon landing page sifatsiz bo'lmaydimi?",
                a: "Byudjetli tarifda sifatdan emas, hajmdan yon bosamiz. Dizayn tayyor asosda moslashtiriladi va bloklar soni cheklanadi. Texnik asos esa barcha tarifda bir xil: kod sifati, yuklanish tezligi, mobil moslashuv, xavfsizlik va bazaviy SEO. Shuning uchun arzon sahifa ham reklamada normal ishlaydi.",
            },
            {
                q: "Arizalar qayerga tushadi?",
                a: "Standart holatda ariza Telegram bot orqali sizga yoki xodimlaringiz guruhiga yuboriladi — bu eng tez va eng ishonchli kanal. Qo'shimcha ravishda elektron pochtaga va Google Sheets jadvaliga yozib borish mumkin. Business tarifidan boshlab amoCRM yoki Bitrix24 bilan bog'lash ham kiradi.",
            },
            {
                q: "Toshkentdan tashqarida bo'lsam ishlay olasizmi?",
                a: "Ha. Loyihalarning katta qismi masofadan olib boriladi: muloqot Telegram va onlayn uchrashuvlar orqali, hujjatlar elektron shaklda rasmiylashtiriladi. O'zbekistonning istalgan viloyatidan hamda chet eldan buyurtma qabul qilamiz. Bog'lanish uchun: +998 90 954 12 62. Shartnoma va hisob-faktura O'zbekiston qonunchiligi bo'yicha rasmiylashtiriladi. Toshkentda ofisda uchrashish ham mumkin.",
            },
            {
                q: "Sayt uchun matnni kim yozadi?",
                a: "Business va Premium tariflarda matn narxga kiradi: biz sizdan brif olamiz, raqobatchilarni ko'rib chiqamiz va sotuvga yo'naltirilgan matn yozamiz. Start tarifida matnni siz berasiz, biz esa uni tahrirlaymiz va sarlavhalarni qayta ishlaymiz. Rasm va logotip har doim sizdan kerak bo'ladi.",
            },
            {
                q: "Kafolat bormi va nima qamrab olinadi?",
                a: "Topshirishdan keyin olti oy davomida texnik xatolar bepul tuzatiladi: ishlamay qolgan shakl, buzilgan moslashuv, yuklanmayotgan sahifa. Bu muddatga kichik matn va rasm o'zgartirishlari ham kiradi. Yangi blok qo'shish yoki dizaynni qayta chizish alohida ish sifatida hisoblanadi. Bunday ishlarning narxini boshlashdan oldin aytamiz va tasdiqingizni olamiz.",
            },
            {
                q: "Landing page qachon mos kelmaydi?",
                a: "Agar sizda o'nlab xizmat yo'nalishi bo'lsa, katalog muntazam yangilansa yoki blog yuritmoqchi bo'lsangiz, bitta sahifa yetmaydi. Bunday holda korporativ sayt yoki internet-do'kon kerak. Shuningdek, foydalanuvchi ro'yxatdan o'tadigan va shaxsiy kabinetda ishlaydigan mahsulot uchun ham landing page emas, veb-ilova to'g'ri yechim bo'ladi.",
            },
        ],
    },
    cta: {
        h: "Landing page buyurtma qilasizmi?",
        p: "Bepul konsultatsiyada taklifingizni muhokama qilamiz, qaysi tarif yetarli ekanini aytamiz va aniq narx bilan muddatni belgilaymiz. Majburiyat yo'q. Telefon: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },
    images: [
        {
            src: "/assets/img/blog/web-cover.webp",
            alt: "Landing page yaratish jarayoni — mobil va desktop maketlari ekranda",
            caption: "Har bir landing page avval telefon ekrani uchun chiziladi, keyin kompyuterga kengaytiriladi.",
        },
        {
            src: "/assets/img/projects/mountain-and-sea.webp",
            alt: "Mountain and Sea kompaniyasi uchun bir sahifali sotuvchi sayt namunasi",
            caption: "Mountain and Sea — bitta taklif atrofida qurilgan bir sahifali sayt.",
        },
        {
            src: "/assets/img/projects/avantika-medex.webp",
            alt: "Avantika Medex klinikasi uchun landing page: xizmatlar va ariza shakli",
            caption: "Avantika Medex — klinika uchun ariza yig'adigan qo'nish sahifasi.",
        },
        {
            src: "/assets/img/blog/web-process.webp",
            alt: "Bir sahifali sayt yaratish bosqichlari: brif, tuzilma, dizayn, dasturlash",
            caption: "Olti bosqichli jarayon: har bosqich oxirida siz natijani tasdiqlaysiz.",
        },
        {
            src: "/assets/img/blog/qurilish-lead.webp",
            alt: "Landing page konversiyasi va reklamadan kelgan arizalar statistikasi",
            caption: "Analitika va konversiya maqsadlari birinchi kundan sozlanadi.",
        },
    ],
    related: ["vizitka-saytlar", "korporativ-saytlar", "google-ads", "seo", "ux-ui-dizayn"],
};

const ru = {
    meta: {
        title: "Создание landing page — цена от 4 млн сум | Innobek",
        description:
            "Создание landing page от 4 000 000 сум. Одностраничный продающий сайт за 5–10 дней: мобильная адаптация, заявки в Telegram, аналитика и 6 месяцев поддержки.",
        keywords: [
            "создание landing page",
            "цена лендинга",
            "одностраничный сайт",
            "заказать лендинг",
            "landing page Ташкент",
            "продающий сайт под ключ",
        ],
    },
    hero: {
        eyebrow: "Landing page",
        h1: "Создание landing page — одна страница, которая приносит заявки с рекламы",
        lead:
            "Одностраничный сайт — самый быстрый в запуске инструмент продаж. Мы строим его под рекламный трафик: проектируем с мобильного экрана, заявки уходят в Telegram, скорость и аналитика настроены к моменту сдачи. Обычный срок — 5–10 рабочих дней.",
        ctaPrimary: "Бесплатная консультация",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Запуск за 5–10 дней",
            "PageSpeed на мобильных 85+",
            "Заявки напрямую в Telegram",
            "6 месяцев техподдержки",
        ],
    },
    intro: {
        h: "Что такое landing page и когда он нужен",
        p: [
            "Landing page — это одностраничный сайт, который ведёт посетителя к одному действию. По меню бродить не нужно: человек прокручивает страницу сверху вниз и узнаёт, кто вы, что предлагаете, сколько это стоит и что делать дальше. Именно за счёт такой простоты одна страница превращает рекламный трафик в заявки эффективнее многостраничного сайта.",
            "Innobek делает лендинг не упражнением в дизайне, а инструментом продаж. Сначала мы разбираемся, кому вы продаёте и с какими возражениями приходит клиент. Затем под это выстраиваем последовательность блоков: заголовок, выгода, доказательства, цена, вопросы и форма заявки. Каждый блок закрывает свою задачу, декоративных вставок мы не добавляем.",
            "Услуга подходит не всем. Если у вас десятки направлений, регулярно обновляемый каталог или раздел новостей, одной страницы будет мало — тогда правильнее корпоративный сайт или интернет-магазин. Мы говорим об этом прямо на консультации и не продаём тариф, который вам не нужен.",
            "На практике лендинг решает две разные задачи. Первая — посадочная страница под Google Ads, Instagram или Telegram-рекламу. Вторая — основной сайт небольшой компании, её официальное лицо в интернете. Техническая база в обоих случаях одинаковая: быстрая загрузка, мобильная вёрстка, корректные метатеги и работающая форма.",
            "Скажем сразу о важном: сама страница клиентов не приводит. Это инструмент, который превращает трафик в заявки. Чтобы люди на неё пришли, нужны реклама, SEO или соцсети. Поэтому ещё до сдачи мы настраиваем Google Analytics и цели по конверсиям — чтобы с первого дня было видно, какой канал действительно работает.",
        ],
    },
    definition: {
        term: "Что такое landing page?",
        text:
            "Landing page — одностраничный сайт, созданный для продажи одного предложения. Вся информация выстроена последовательно, а посетитель ведётся к единственной цели: оставить заявку или позвонить.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не платные опции — они есть даже в самом бюджетном варианте.",
        items: [
            "Бесплатная консультация и составление техзадания",
            "Помощь с регистрацией домена и настройка DNS",
            "Бесплатный SSL-сертификат и работа по HTTPS",
            "Адаптация под телефон, планшет и десктоп",
            "Форма заявки с отправкой сообщения в Telegram",
            "Сжатие изображений, кеширование, оптимизация скорости",
            "Метатеги, sitemap.xml, robots.txt и Open Graph",
            "Подключение Google Analytics и Search Console",
            "Короткая видеоинструкция по управлению сайтом",
            "6 месяцев техподдержки после сдачи",
        ],
    },
    benefits: {
        eyebrow: "Преимущества",
        h: "Почему одна страница часто работает лучше большого сайта",
        sub: "Сила лендинга не в объёме, а в фокусе. Ниже — что это даёт на практике.",
        items: [
            {
                t: "Понятный бюджет заранее",
                d: "Страница одна, поэтому объём дизайна и разработки небольшой. Цена в два-три раза ниже, чем у корпоративного сайта, а смета согласуется в начале — доплат по ходу работы не возникает.",
            },
            {
                t: "Быстрый запуск",
                d: "Простой вариант сдаём за 5–7 рабочих дней, с индивидуальным дизайном и анимацией — за 10–15. Не придётся откладывать рекламную кампанию на пару месяцев.",
            },
            {
                t: "Выше конверсия",
                d: "У посетителя один путь: оставить заявку или позвонить. Нет меню и внутренних ссылок, которые рассеивают внимание, поэтому с того же трафика приходит больше обращений.",
            },
            {
                t: "Мобильные в приоритете",
                d: "Большая часть визитов в Узбекистане идёт с телефона. Макет рисуется сначала под мобильный экран и только потом расширяется до десктопа. Кнопки и поля формы достаточно крупные, чтобы по ним было удобно попадать пальцем.",
            },
            {
                t: "Готовность к рекламе",
                d: "Подключаем Google Analytics, Meta Pixel и цели по конверсиям. Оптимизация скорости снижает стоимость клика, а UTM-разметка показывает, какой канал реально приносит заявки.",
            },
            {
                t: "Можно расширить позже",
                d: "Когда бизнес вырастет, превращаем лендинг в корпоративный сайт или интернет-магазин. Дизайн-система и код переиспользуются, поэтому расширение обходится дешевле разработки с нуля.",
            },
            {
                t: "Результат измерим",
                d: "После запуска видно, сколько визитов превращается в заявки. Если конверсия низкая, понятно, где именно: заголовок, цена или форма. Правки вносим по цифрам, а не по ощущениям.",
            },
            {
                t: "Код и материалы остаются у вас",
                d: "При сдаче передаём домен, доступы к хостингу, макет в Figma и архив кода. Вы не привязаны к нам — при желании сайт сможет вести другая команда.",
            },
        ],
    },
    audience: {
        eyebrow: "Кому подходит",
        h: "В каких случаях лендинг полезнее всего",
        sub: "В этих ситуациях одностраничный сайт даёт результат быстрее и дешевле любого другого формата.",
        items: [
            {
                t: "Одна услуга или один продукт",
                d: "Стоматология, клиника, ремонт, юридические услуги, продажа оборудования. Когда предложение конкретное, одной страницы хватает, чтобы рассказать всё.",
            },
            {
                t: "Те, кто вкладывается в рекламу",
                d: "Если вы платите за Google Ads или Instagram, вести трафик на продающую страницу дешевле, чем на профиль в соцсети.",
            },
            {
                t: "Курсы и мероприятия",
                d: "Программа, спикеры, цена и форма регистрации на одной странице. Заявки приходят в Telegram-группу, список не приходится вести вручную.",
            },
            {
                t: "Новый бизнес",
                d: "При ограниченном бюджете начните с лендинга и проверьте спрос. Когда пойдут первые продажи, перейдёте к более крупному сайту.",
            },
            {
                t: "Акции и запуск новинок",
                d: "Под каждую кампанию открывается отдельная страница, и её результат считается отдельно. Основной сайт при этом не трогается.",
            },
            {
                t: "Тендеры и партнёрство",
                d: "Отсутствие официального сайта мешает в серьёзных переговорах. Одностраничный сайт закрывает этот вопрос примерно за неделю.",
            },
            {
                t: "Стройка и недвижимость",
                d: "Под каждый жилой комплекс или объект делается своя страница: расположение, планировки, цены и форма брони собраны в одном месте.",
            },
            {
                t: "Выход на зарубежного клиента",
                d: "Отдельная версия на английском или русском работает для экспорта и аутсорс-услуг. Текст не переводится дословно, а пишется заново под этот рынок.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость landing page — три тарифа",
        sub: "Цены открытые. В каждый тариф входят настройка домена, размещение и поддержка.",
        note:
            "Итоговая смета подтверждается после бесплатной консультации и зависит от числа блоков и функционала. Оплата в два этапа: 50% в начале, 50% при сдаче. Домен и хостинг оплачиваются провайдеру отдельно — примерно 400 000 – 1 200 000 сум в год.",
        tiers: [
            {
                name: "Start",
                tagline: "Бюджетный одностраничный сайт",
                price: "4 000 000",
                priceNote: "сум",
                term: "5–7 рабочих дней",
                best: "Новому бизнесу и продаже одной услуги",
                features: [
                    "Дизайн на готовой основе под ваш бренд",
                    "6–8 контентных блоков",
                    "Адаптация под все устройства",
                    "Форма заявки и уведомления в Telegram",
                    "Базовое техническое SEO",
                    "Подключение Google Analytics",
                    "Настройка домена и хостинга",
                    "6 месяцев поддержки",
                ],
            },
            {
                name: "Business",
                tagline: "Индивидуальный дизайн и админка",
                price: "9 000 000",
                priceNote: "сум",
                term: "10–15 рабочих дней",
                best: "Тем, кто активно рекламируется и хочет сам менять контент",
                featured: true,
                features: [
                    "Дизайн с нуля в Figma",
                    "Анимации при прокрутке и микровзаимодействия",
                    "Админка: тексты, изображения и цены меняете сами",
                    "Две или три языковые версии",
                    "Продающие тексты под вашу аудиторию",
                    "Расширенное SEO и разметка Schema.org",
                    "Meta Pixel и настройка целей",
                    "Интеграция с CRM или Google Sheets",
                    "6 месяцев поддержки",
                ],
            },
            {
                name: "Premium",
                tagline: "Нестандартное решение",
                price: "18 000 000",
                priceNote: "сум",
                term: "3–6 недель",
                best: "Когда нужен калькулятор, бронирование или сложная интеграция",
                features: [
                    "Интерактивные сцены, видеофон и 3D-элементы",
                    "Калькулятор, конфигуратор или модуль брони",
                    "Онлайн-оплата: Payme, Click, Uzum",
                    "Интеграция с amoCRM, Bitrix24 или 1С",
                    "A/B-тесты и работа над конверсией",
                    "Инфраструктура под нагрузку и мониторинг",
                    "Персональный менеджер проекта",
                    "12 месяцев поддержки",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как мы создаём landing page",
        sub: "Шесть этапов. В конце каждого вы видите результат и согласовываете его — следующий этап начинается только после этого.",
        steps: [
            {
                t: "Консультация и бриф",
                time: "1 день",
                d: "Обсуждаем бизнес, портрет клиента и конкурентов. Говорим, какого тарифа достаточно. На этом же этапе фиксируются точная цена и срок.",
            },
            {
                t: "Структура и тексты",
                time: "1–2 дня",
                d: "Составляем последовательность блоков и пишем текст под каждый. Заголовки подбираем так, чтобы они закрывали возражения клиента. Вы согласовываете.",
            },
            {
                t: "Дизайн",
                time: "2–5 дней",
                d: "Рисуем мобильный и десктопный макет в Figma. Цвета, шрифты и стиль подстраиваем под бренд. Правки в согласованном объёме бесплатны.",
            },
            {
                t: "Разработка и тесты",
                time: "3–7 дней",
                d: "Собираем страницу на React, оптимизируем скорость и SEO. Формы, работу в разных браузерах и на разных размерах экрана проверяем вручную.",
            },
            {
                t: "Запуск",
                time: "1 день",
                d: "Подключаем домен, настраиваем аналитику и цели, отправляем сайт на индексацию в Google. Передаём инструкцию, начинается срок поддержки.",
            },
            {
                t: "Наблюдение и правки",
                time: "6 месяцев",
                d: "В первые недели смотрим статистику заявок. При необходимости меняем заголовок, положение кнопки или поля формы — это входит в поддержку.",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Из недавних работ",
        sub: "Каждый проект сделан с нуля: структура, дизайн, тексты и техническая часть — наши.",
        cta: "Все проекты",
        slugs: ["mountain-and-sea", "avantika-medex", "global-building-group", "atlet"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Конкретные ответы на то, что чаще всего спрашивают про создание лендинга.",
        items: [
            {
                q: "Сколько стоит создание landing page?",
                a: "Цена начинается от 4 000 000 сум. Это страница на готовой основе, полностью адаптированная под мобильные и готовая к индексации. Вариант с индивидуальным дизайном, анимацией и админкой — от 9 000 000 сум. Если нужны калькулятор, онлайн-оплата или интеграция с CRM, стоимость начинается от 18 000 000 сум и зависит от объёма.",
            },
            {
                q: "Сколько по времени делается одностраничный сайт?",
                a: "Тариф Start обычно сдаётся за 5–7 рабочих дней, Business занимает 10–15 рабочих дней. Для premium-решений нужно 3–6 недель. Срок зависит и от того, как быстро вы передадите тексты, логотип и фотографии. Если контент готов, процесс сокращается на день-два. Срок фиксируем в договоре и предупреждаем заранее, если что-то сдвигается.",
            },
            {
                q: "Лендинг и одностраничный сайт — это одно и то же?",
                a: "Практически да. Термином landing page чаще называют посадочную страницу под рекламный трафик, а одностраничным сайтом — формат, который служит основным сайтом компании. Устройство одинаковое, разница только в цели. Мы собираем страницу так, чтобы она справлялась с обеими задачами. То есть страница одинаково работает и в рекламе, и в поиске.",
            },
            {
                q: "Смогу ли я сам редактировать сайт?",
                a: "В тарифах Business и Premium есть админка: тексты, изображения, цены и блоки меняются без программиста. В тарифе Start админки нет, но в течение шести месяцев поддержки мелкие правки мы вносим бесплатно. Админку можно добавить и позже, отдельной доработкой. Стоимость зависит от структуры страницы и начинается примерно от 3 000 000 сум.",
            },
            {
                q: "Будет ли лендинг виден в Google?",
                a: "Сайт сдаётся готовым к индексации: корректные метатеги, семантические заголовки, sitemap.xml, robots.txt и разметка Schema.org. Но одна страница ранжируется по ограниченному числу запросов. Для конкурентной выдачи нужна постоянная SEO-работа и контент — это отдельная услуга. Обычно первые заметные результаты появляются через три-шесть месяцев работы.",
            },
            {
                q: "Домен и хостинг входят в цену?",
                a: "Работы по настройке входят: помогаем зарегистрировать домен, подключаем DNS, устанавливаем SSL. Сама оплата домена и хостинга идёт провайдеру напрямую — примерно 400 000 – 1 200 000 сум в год. Подскажем, какой вариант выгоднее под вашу нагрузку. Домен оформляется на вас, у себя мы его не держим.",
            },
            {
                q: "Дешёвый лендинг — значит некачественный?",
                a: "В бюджетном тарифе мы экономим на объёме, а не на качестве. Дизайн адаптируется на готовой основе, количество блоков ограничено. Техническая база во всех тарифах одна: чистый код, скорость загрузки, мобильная вёрстка, безопасность и базовое SEO. Поэтому недорогая страница нормально работает в рекламе.",
            },
            {
                q: "Куда приходят заявки?",
                a: "По умолчанию заявка уходит через Telegram-бота вам или в группу сотрудников — это самый быстрый и надёжный канал. Дополнительно можно дублировать на почту и записывать в таблицу Google Sheets. Начиная с тарифа Business подключаем amoCRM или Bitrix24. Работу уведомлений проверяем на реальной заявке перед сдачей.",
            },
            {
                q: "Вы работаете, если я не в Ташкенте?",
                a: "Да. Большую часть проектов ведём удалённо: общение в Telegram и на онлайн-встречах, документы оформляем электронно. Принимаем заказы из любого региона Узбекистана и из-за рубежа. Телефон для связи: +998 90 954 12 62. Договор и счёт оформляем по законодательству Узбекистана. При желании встречаемся в офисе в Ташкенте.",
            },
            {
                q: "Кто пишет тексты для лендинга?",
                a: "В тарифах Business и Premium тексты входят в цену: берём у вас бриф, изучаем конкурентов и пишем продающий текст. В тарифе Start текст даёте вы, а мы его редактируем и переписываем заголовки. Фотографии и логотип в любом случае нужны от вас.",
            },
            {
                q: "Есть ли гарантия и что в неё входит?",
                a: "Полгода после сдачи технические ошибки исправляются бесплатно: неработающая форма, съехавшая вёрстка, недоступная страница. В этот же срок входят мелкие правки текста и картинок. Добавление новых блоков или переработка дизайна считаются отдельной работой и оцениваются заранее. Цену называем до начала работ и получаем ваше подтверждение.",
            },
            {
                q: "Когда лендинг не подходит?",
                a: "Если у вас десятки направлений, каталог обновляется постоянно или вы собираетесь вести блог, одной страницы будет мало — нужен корпоративный сайт или интернет-магазин. Для продукта, где пользователь регистрируется и работает в личном кабинете, правильное решение тоже не лендинг, а веб-приложение.",
            },
        ],
    },
    cta: {
        h: "Готовы заказать landing page?",
        p: "На бесплатной консультации разберём ваше предложение, скажем, какого тарифа достаточно, и зафиксируем точную цену и срок. Без обязательств. Телефон: +998 90 954 12 62.",
        button: "Получить консультацию",
        secondary: "Написать в Telegram",
    },
    images: [
        {
            src: "/assets/img/blog/web-cover.webp",
            alt: "Процесс создания landing page — мобильный и десктопный макеты на экране",
            caption: "Каждый лендинг рисуется сначала под телефон и только потом расширяется до десктопа.",
        },
        {
            src: "/assets/img/projects/mountain-and-sea.webp",
            alt: "Пример одностраничного продающего сайта для компании Mountain and Sea",
            caption: "Mountain and Sea — одностраничный сайт, построенный вокруг одного предложения.",
        },
        {
            src: "/assets/img/projects/avantika-medex.webp",
            alt: "Landing page клиники Avantika Medex с блоком услуг и формой заявки",
            caption: "Avantika Medex — посадочная страница клиники, собирающая заявки.",
        },
        {
            src: "/assets/img/blog/web-process.webp",
            alt: "Этапы создания одностраничного сайта: бриф, структура, дизайн, разработка",
            caption: "Шесть этапов работы: в конце каждого вы согласовываете результат.",
        },
        {
            src: "/assets/img/blog/qurilish-lead.webp",
            alt: "Статистика конверсии лендинга и заявок, пришедших с рекламы",
            caption: "Аналитика и цели по конверсиям настраиваются с первого дня.",
        },
    ],
    related: ["vizitka-saytlar", "korporativ-saytlar", "google-ads", "seo", "ux-ui-dizayn"],
};

const content = { uz, ru };

export default content;
